import "core-js/modules/es.array.push.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "hover-bridge-area"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "menu-icon-box"
};
const _hoisted_4 = {
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_5 = ["d"];
const _hoisted_6 = {
  class: "menu-label"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "ball-text-overlay"
};
const _hoisted_9 = {
  class: "status"
};
const _hoisted_10 = {
  key: 0,
  class: "alarm-glow"
};
import { ref, reactive, onMounted, onUnmounted, computed } from 'vue';
import { useRouter } from 'vue-router';
export default {
  __name: 'AlarmBall',
  props: {
    // 是否采用绝对定位（默认为 fixed）
    absolute: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const router = useRouter();

    // 是否处于报警状态
    const isAlarm = ref(false);
    // 鼠标是否悬停在球上
    const isHovered = ref(false);

    // 容器 DOM 引用
    const containerRef = ref(null);
    // 视口或父容器尺寸
    const viewport = reactive({
      width: window.innerWidth,
      height: window.innerHeight
    });

    /**
     * 更新可用区域尺寸
     */
    const updateViewport = () => {
      if (props.absolute && containerRef.value?.parentElement) {
        const parent = containerRef.value.parentElement;
        viewport.width = parent.clientWidth || parent.offsetWidth;
        viewport.height = parent.clientHeight || parent.offsetHeight;
      } else {
        viewport.width = window.innerWidth;
        viewport.height = window.innerHeight;
      }
    };

    // 球的当前坐标位置，初始设为右下角
    const position = reactive({
      x: window.innerWidth - 100,
      y: window.innerHeight - 100
    });

    // 是否正在拖拽
    const isDragging = ref(false);
    // 拖拽起始位置
    const dragStartPos = reactive({
      x: 0,
      y: 0
    });
    // 是否发生了实际位移（用于区分点击与拖拽）
    const hasMoved = ref(false);

    // 菜单项配置
    const menuItems = [{
      key: 'dashboard',
      label: '监控中心',
      path: '/ht/v1',
      icon: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'
    }, {
      key: 'fault',
      label: '故障台账',
      path: '/ht/v1/fault',
      icon: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z'
    }, {
      key: 'fire-alarm',
      label: '火灾报警',
      path: '/ht/v1/fire-alarm',
      icon: 'M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z'
    }, {
      key: 'extinguish',
      label: '灭火系统',
      path: '/ht/v1/extinguish',
      icon: 'M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8zm0 18c-2.21 0-4-1.79-4-4 0-1.3.62-2.48 1.64-3.36.24-.21.54-.34.86-.38.32.04.62.17.86.38C12.38 12.52 13 13.7 13 15c0 2.21-1.79 4-4 4z'
    }, {
      key: 'electrical',
      label: '电气火灾',
      path: '/ht/v1/electrical',
      icon: 'M7 2v11h3v9l7-12h-4l4-8z'
    }, {
      key: 'duty',
      label: '值班事务',
      path: '/ht/v1/duty',
      icon: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z'
    }, {
      key: 'record',
      label: '消防档案',
      path: '/ht/v1/record',
      icon: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z'
    }, {
      key: 'safety',
      label: '安全指数',
      path: '/ht/v1/safety',
      icon: 'M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z'
    }];

    /**
     * 根据球所在位置动态计算菜单弹出逻辑
     */
    const menuConfig = computed(() => {
      const threshold = 210; // 距离边缘的阈值
      const distToLeft = position.x;
      const distToRight = viewport.width - position.x;
      const distToTop = position.y;
      const distToBottom = viewport.height - position.y;
      const nearLeft = distToLeft < threshold;
      const nearRight = distToRight < threshold;
      const nearTop = distToTop < threshold;
      const nearBottom = distToBottom < threshold;

      // 1. 完全不在边缘：360度全圆
      if (!nearLeft && !nearRight && !nearTop && !nearBottom) {
        return {
          startAngle: -Math.PI / 2,
          sweepAngle: 2 * Math.PI,
          isFull: true,
          radius: 120,
          useLayers: false
        };
      }

      // 2. 识别角落
      const isCorner = (nearLeft || nearRight) && (nearTop || nearBottom);
      if (isCorner) {
        let baseAngle;
        if (nearLeft && nearTop) baseAngle = Math.PI / 4; // 左上 -> 指向右下
        else if (nearRight && nearTop) baseAngle = 3 * Math.PI / 4; // 右上 -> 指向左下
        else if (nearRight && nearBottom) baseAngle = -3 * Math.PI / 4; // 右下 -> 指向左上
        else baseAngle = -Math.PI / 4; // 左下 -> 指向右上

        return {
          // 在角落时，将展开角度限制在 90 度 (Math.PI / 2)，防止超出屏幕
          startAngle: baseAngle - Math.PI / 2 / 2,
          sweepAngle: Math.PI / 2,
          isFull: false,
          radius: 130,
          // 增加第一层半径，减少拥挤感
          useLayers: true // 开启分层延伸模式
        };
      }

      // 3. 正边缘：180度半圆分布
      let baseAngle = 0;
      if (nearLeft) baseAngle = 0; // 左边缘 -> 向右展开
      else if (nearRight) baseAngle = Math.PI; // 右边缘 -> 向左展开
      else if (nearTop) baseAngle = Math.PI / 2; // 上边缘 -> 向下展开
      else if (nearBottom) baseAngle = -Math.PI / 2; // 下边缘 -> 向上展开

      return {
        startAngle: baseAngle - Math.PI / 2,
        sweepAngle: Math.PI,
        isFull: false,
        radius: 140,
        useLayers: false
      };
    });

    /**
     * 计算报警球的收起/半隐藏样式
     */
    const ballDockStyle = computed(() => {
      // 如果正在拖拽或鼠标悬浮，不收起
      if (isHovered.value || isDragging.value) return {};
      const threshold = 110; // 触发收起的距离
      const offset = 40; // 收起的像素量
      let translateX = 0;
      let translateY = 0;
      if (position.x <= threshold) translateX = -offset;
      if (position.x >= viewport.width - threshold) translateX = offset;
      if (position.y <= threshold) translateY = -offset;
      if (position.y >= viewport.height - threshold) translateY = offset;
      if (translateX !== 0 || translateY !== 0) {
        return {
          transform: `translate(${translateX}px, ${translateY}px)`,
          opacity: 0.6,
          filter: 'grayscale(0.3)'
        };
      }
      return {};
    });

    /**
     * 根据索引获取菜单项的定位样式
     */
    const getMenuItemStyle = index => {
      const {
        startAngle,
        sweepAngle,
        isFull,
        radius,
        useLayers
      } = menuConfig.value;
      const total = menuItems.length;
      let angle;
      let currentRadius = radius;
      if (useLayers) {
        // 角落专用：分层扇形延伸逻辑
        const itemsPerLayer = 3; // 每层减少到 3 个，增加横向间距
        const layer = Math.floor(index / itemsPerLayer);
        const indexInLayer = index % itemsPerLayer;

        // 强制按每层槽位计算角度，实现径向对齐
        angle = startAngle + indexInLayer / (itemsPerLayer - 1) * sweepAngle;
        currentRadius = radius + layer * 85; // 增加层间距到 85px
      } else {
        // 普通环绕逻辑
        if (isFull) {
          angle = startAngle + index / total * sweepAngle;
        } else {
          angle = startAngle + index / (total - 1) * sweepAngle;
        }
      }
      const x = Math.cos(angle) * currentRadius;
      const y = Math.sin(angle) * currentRadius;
      return {
        left: '50%',
        top: '50%',
        marginLeft: '-30px',
        marginTop: '-30px',
        transform: `translate(${x}px, ${y}px)`
      };
    };

    /**
     * 鼠标按下起始拖拽
     */
    const handleMouseDown = e => {
      isDragging.value = true;
      hasMoved.value = false;
      dragStartPos.x = e.clientX;
      dragStartPos.y = e.clientY;
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    };

    /**
     * 拖拽移动处理
     */
    const handleMouseMove = e => {
      if (!isDragging.value) return;
      let dx = e.clientX - dragStartPos.x;
      let dy = e.clientY - dragStartPos.y;

      // 如果是绝对定位且父容器缩放了，需要校准位移速度
      if (props.absolute && containerRef.value?.parentElement) {
        const parent = containerRef.value.parentElement;
        const rect = parent.getBoundingClientRect();
        const scaleX = rect.width / parent.offsetWidth;
        const scaleY = rect.height / parent.offsetHeight;
        if (scaleX > 0) dx /= scaleX;
        if (scaleY > 0) dy /= scaleY;
      }

      // 只有移动距离超过 5px 才判定为拖拽
      if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
        hasMoved.value = true;
      }
      position.x += dx;
      position.y += dy;
      dragStartPos.x = e.clientX;
      dragStartPos.y = e.clientY;

      // 边界检查 - 使用当前 viewport 尺寸
      position.x = Math.max(100, Math.min(viewport.width - 100, position.x));
      position.y = Math.max(100, Math.min(viewport.height - 100, position.y));
    };

    /**
     * 拖拽结束处理
     */
    const handleMouseUp = () => {
      isDragging.value = false;
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };

    /**
     * 中心球点击处理
     */
    const handleCenterClick = () => {
      // 如果是拖拽操作，不触发点击
      if (hasMoved.value) return;
      router.push('/ht/v1/alert');
    };

    /**
     * 菜单项点击处理
     */
    const handleMenuClick = item => {
      router.push(item.path);
    };
    onMounted(() => {
      updateViewport();
      position.x = viewport.width - 100;
      position.y = viewport.height - 100;
      if (props.absolute) {
        // 如果是绝对定位，可能需要 ResizeObserver 监听父容器
        const observer = new ResizeObserver(updateViewport);
        if (containerRef.value?.parentElement) {
          observer.observe(containerRef.value.parentElement);
        }
        onUnmounted(() => observer.disconnect());
      } else {
        // 监听窗口大小变化，防止球掉出屏幕
        window.addEventListener('resize', () => {
          updateViewport();
          position.x = Math.max(100, Math.min(position.x, viewport.width - 100));
          position.y = Math.max(100, Math.min(position.y, viewport.height - 100));
        });
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "containerRef",
        ref: containerRef,
        class: _normalizeClass(["alarm-ball-container", {
          'is-absolute': props.absolute
        }]),
        style: _normalizeStyle({
          left: position.x - 300 + 'px',
          top: position.y - 300 + 'px'
        }),
        onMouseleave: _cache[1] || (_cache[1] = $event => isHovered.value = false)
      }, [isHovered.value ? (_openBlock(), _createElementBlock("div", _hoisted_1)) : _createCommentVNode("", true), _createVNode(_TransitionGroup, {
        name: "menu-fade"
      }, {
        default: _withCtx(() => [isHovered.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(menuItems, (item, index) => {
          return _createElementVNode("div", {
            key: item.key,
            class: "menu-item",
            style: _normalizeStyle(getMenuItemStyle(index)),
            onClick: _withModifiers($event => handleMenuClick(item), ["stop"])
          }, [_createElementVNode("div", _hoisted_3, [(_openBlock(), _createElementBlock("svg", _hoisted_4, [_createElementVNode("path", {
            d: item.icon
          }, null, 8, _hoisted_5)]))]), _createElementVNode("div", _hoisted_6, _toDisplayString(item.label), 1)], 12, _hoisted_2);
        }), 64)) : _createCommentVNode("", true)]),
        _: 1
      }), _createElementVNode("div", {
        class: _normalizeClass(["center-ball", {
          'is-alarm': isAlarm.value,
          'is-hovered': isHovered.value
        }]),
        style: _normalizeStyle(ballDockStyle.value),
        onMousedown: _withModifiers(handleMouseDown, ["stop"]),
        onMouseenter: _cache[0] || (_cache[0] = $event => isHovered.value = true),
        onClick: _withModifiers(handleCenterClick, ["stop"])
      }, [_createElementVNode("img", {
        src: isAlarm.value ? '/images/sentry/AlarmBall-red.png' : '/images/sentry/AlarmBall-white.png',
        class: "ball-image",
        alt: "消防报警球",
        draggable: "false"
      }, null, 8, _hoisted_7), _createElementVNode("div", _hoisted_8, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "title"
      }, "消防报警球", -1)), _createElementVNode("div", _hoisted_9, _toDisplayString(isAlarm.value ? '火警报警' : '正常运行'), 1)]), isAlarm.value ? (_openBlock(), _createElementBlock("div", _hoisted_10)) : _createCommentVNode("", true)], 38)], 38);
    };
  }
};